// extracted by mini-css-extract-plugin
export default {"div":"carousal_div__n07wv"};